// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"_35mkd","BreadcrumbItem":"_1QAwF"};